import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    RowDataManufactur,
    STORE_UNDERDESIGNDATA,
    STORE_DESIGNREADYDATA,
    STORE_MHOLDORDERDATA,
    STORE_MNEWORDERDATA,
    STORE_MINPRODUCTIONORDERDATA,
    STORE_M_FILTERED_DATA,
    STORE_M_FILTERLESS_DATA,
    STORE_MCOMPLETEORDERDATA, STORE_M_PREVIEWORDER_DATA, STORE_M_FILTER_DATA_EXPORT
} from 'src/reducers/manufactur';
import { STORE_ERROR_FILES_UPLOADED, STORE_ERROR_FILES_UPLOADED_MSG } from 'src/reducers/errors';
import { commonDateFormat } from './completedOrderDateAction';
import { STORE_LOADER } from 'src/reducers/landingPage';

let productionStatusTimer: NodeJS.Timer;

// tslint:disable-next-line: no-any
export const transformDataforExport = (data: any[], dateFields: string[], dispatch: Dispatch<AppState>, getState: () => AppState) => {

    return new Promise((resolve, reject) => {

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}api/getModifiedDataforExport`,
            data: { data, dateFields },
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: getState().user.userDetails.s || ''
            }
        })
            .then((result) => {
                resolve(result.data);
            })
            .catch((error) => {
                resolve([]);
            });

    });

};

export const commonDateFormatList = (actualDate: Date | null, type: string) => {

    const date = typeof (actualDate) === 'object' ? actualDate : new Date(actualDate);

    if (type === 'date' && date !== null) {

        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const final = [year, day, month].join('');

        return final;
    } else if (type === 'time' && date !== null) {

        const hours = `0${date.getHours()}`.slice(-2);
        const minutes = `0${date.getMinutes()}`.slice(-2);
        const seconds = `0${date.getSeconds()}`.slice(-2);
        const strTime = `${hours}:${minutes}:${seconds}`;

        return strTime;
    }
    return null;

};

export const getUnderDesignData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=INDESIGN`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {

            if (response.data[0].orderno !== '') {

                const underDesignData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_UNDERDESIGNDATA, underDesignData } as AnyAction);
            } else {

                const underDesignData: RowDataManufactur[] = [];
                dispatch({ type: STORE_UNDERDESIGNDATA, underDesignData } as AnyAction);
            }

        } else {

            const underDesignData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_UNDERDESIGNDATA, underDesignData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {

        const underDesignData: RowDataManufactur[] = [];
        dispatch({ type: STORE_UNDERDESIGNDATA, underDesignData } as AnyAction);

    });

};

export const getDesignReadyOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=READY`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {
                const designReadyData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_DESIGNREADYDATA, designReadyData } as AnyAction);
            } else {
                const designReadyData: RowDataManufactur[] = [];
                dispatch({ type: STORE_DESIGNREADYDATA, designReadyData } as AnyAction);
            }
        } else {
            const designReadyData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_DESIGNREADYDATA, designReadyData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {
        const designReadyData: RowDataManufactur[] = [];
        dispatch({ type: STORE_DESIGNREADYDATA, designReadyData } as AnyAction);
    });

};

export const getMHoldOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=HOLD`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {

                const mHoldOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_MHOLDORDERDATA, mHoldOrderData } as AnyAction);
            } else {

                const mHoldOrderData: RowDataManufactur[] = [];
                dispatch({ type: STORE_MHOLDORDERDATA, mHoldOrderData } as AnyAction);
            }

        } else {

            const mHoldOrderData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_MHOLDORDERDATA, mHoldOrderData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {

        const mHoldOrderData: RowDataManufactur[] = [];
        dispatch({ type: STORE_MHOLDORDERDATA, mHoldOrderData } as AnyAction);
    });

};

export const getMNewOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=NEW`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {

                const mNewOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_MNEWORDERDATA, mNewOrderData } as AnyAction);
            } else {

                const mNewOrderData: RowDataManufactur[] = [];
                dispatch({ type: STORE_MNEWORDERDATA, mNewOrderData } as AnyAction);
            }

        } else {

            const mNewOrderData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_MNEWORDERDATA, mNewOrderData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {

        const mNewOrderData: RowDataManufactur[] = [];
        dispatch({ type: STORE_MNEWORDERDATA, mNewOrderData } as AnyAction);
    });

};

export const getMCompleteOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=COMPLETED`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {

                const mCompleteOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_MCOMPLETEORDERDATA, mCompleteOrderData } as AnyAction);
            } else {

                const mCompleteOrderData: RowDataManufactur[] = [];
                dispatch({ type: STORE_MCOMPLETEORDERDATA, mCompleteOrderData } as AnyAction);
            }

        } else {

            const mCompleteOrderData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_MCOMPLETEORDERDATA, mCompleteOrderData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {

        const mCompleteOrderData: RowDataManufactur[] = [];
        dispatch({ type: STORE_MCOMPLETEORDERDATA, mCompleteOrderData } as AnyAction);
    });

};

export const filterApi = async (dataParam: object, dispatch: Dispatch<AppState>, getState: () => AppState, filter: boolean) => {

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}getfilterdata`,
        data: dataParam,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(async function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {
                if (filter) {
                    const mfilteredOrderData: RowDataManufactur[] = response.data;
                    dispatch({ type: STORE_M_FILTERED_DATA, mfilteredOrderData } as AnyAction);
                    const mfiltersdataExport = await transformDataforExport(response.data, ['orderdate', 'completedon'], dispatch, getState);
                    dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
                } else {
                    const mfilterLessOrderData: RowDataManufactur[] = response.data;
                    dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);
                    const mfiltersdataExport = await transformDataforExport(response.data, ['orderdate', 'completedon'], dispatch, getState);
                    dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
                }
            } else {

                const errorFileUploadedOpen = true;
                const errorfilemsg = 'No Records Found!';
                dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

                if (filter) {
                    const mfilteredOrderData: RowDataManufactur[] = [];
                    dispatch({ type: STORE_M_FILTERED_DATA, mfilteredOrderData } as AnyAction);
                    const mfiltersdataExport: RowDataManufactur[] = [];
                    dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
                } else {
                    const mfilterLessOrderData: RowDataManufactur[] = [];
                    dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);
                    const mfiltersdataExport: RowDataManufactur[] = [];
                    dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
                }
            }
        } else {
            if (filter) {
                const mfilteredOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_M_FILTERED_DATA, mfilteredOrderData } as AnyAction);
                const mfiltersdataExport = await transformDataforExport(response.data, ['orderdate', 'completedon'], dispatch, getState);
                dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
            } else {
                const mfilterLessOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);
                const mfiltersdataExport = await transformDataforExport(response.data, ['orderdate', 'completedon'], dispatch, getState);
                dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
            }
        }

        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

    }).catch(function (error: AxiosError) {

        // const errorFileUploadedOpen = true;
        // const errorfilemsg = 'Something went wrong!';
        // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        // dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

        if (filter) {
            const mfilteredOrderData: RowDataManufactur[] = [];
            dispatch({ type: STORE_M_FILTERED_DATA, mfilteredOrderData } as AnyAction);
            const mfiltersdataExport: RowDataManufactur[] = [];
            dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
        } else {
            const mfilterLessOrderData: RowDataManufactur[] = [];
            dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);
            const mfiltersdataExport: RowDataManufactur[] = [];
            dispatch({ type: STORE_M_FILTER_DATA_EXPORT, mfiltersdataExport } as AnyAction);
        }

        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    });
};

export const getMInproductionOrderDataFilter = (fcno: string, tcno: string, startDate: Date | null, endDate: Date | null, status: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const dataParam = {
            listType: 'ordpndng',
            data: {
                pusername: getState().user.userDetails.userName,
                pstatus: status,
                fcaseno: fcno,
                tcaseno: tcno,
                fdate: commonDateFormat(startDate, 'date'),
                tdate: commonDateFormat(endDate, 'date')
            }
        };

        if (!dataParam.data.fcaseno || !dataParam.data.tcaseno) {
            dataParam.listType = 'ordpndnr';
        }

        filterApi(dataParam, dispatch, getState, true);

    };
};

export const getMInproductionOrderDataFilterLess = (fcno: string, tcno: string, startDate: Date | null, endDate: Date | null, status: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const dataParam = {
            listType: 'ordpndn2',
            data: {
                pusername: getState().user.userDetails.userName,
                pstatus: '',
                fcaseno: '',
                tcaseno: '',
                fdate: '',
                tdate: ''
            }
        };

        filterApi(dataParam, dispatch, getState, false);

        if (productionStatusTimer) {
            clearInterval(productionStatusTimer);
        }
        productionStatusTimer = setInterval(() => { filterApi(dataParam, dispatch, getState, false); }, 300000);

    };
};

export const getCustDataFilter = (fcno: string, tcno: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const dataParam = {
            listType: 'curecdon',
            data: {
                pusername: getState().user.userDetails.userName,
                fcaseno: fcno,
                tcaseno: tcno
            }
        };

        filterApi(dataParam, dispatch, getState, true);
    };
};

export const getMInproductionOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=mrecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=INPRODUCTION`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(function (response: AxiosResponse) {

        if (response.data.length === 1) {
            if (response.data[0].orderno !== '') {
                const mInproductionOrderData: RowDataManufactur[] = response.data;
                dispatch({ type: STORE_MINPRODUCTIONORDERDATA, mInproductionOrderData } as AnyAction);
            } else {
                const mInproductionOrderData: RowDataManufactur[] = [];
                dispatch({ type: STORE_MINPRODUCTIONORDERDATA, mInproductionOrderData } as AnyAction);
            }
        } else {
            const mInproductionOrderData: RowDataManufactur[] = response.data;
            dispatch({ type: STORE_MINPRODUCTIONORDERDATA, mInproductionOrderData } as AnyAction);
        }

    }).catch(function (error: AxiosError) {
        const mInproductionOrderData: RowDataManufactur[] = [];
        dispatch({ type: STORE_MINPRODUCTIONORDERDATA, mInproductionOrderData } as AnyAction);
    });

};

export const resetPreviewData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const previewOrderData = {
        userRxdata: [],
        getUserMessage: [],
        getFileData: []
    };

    dispatch({ type: STORE_M_PREVIEWORDER_DATA, previewOrderData } as AnyAction);

};

export const getPreviewData = (orderno: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const sessionid = getState().user.userDetails.s || '';

        const previewOrderData = {
            userRxdata: [],
            getUserMessage: [],
            getFileData: [],
            caseNotes: ''
        };

        const index = [0, 1, 2, 3];

        for (const indexVal of index) {
            if (indexVal === 0) {

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}getRxOrderDetails?orderId=${orderno}`,
                    headers: {
                        sessionid: sessionid || ''
                    },
                }).then(function (response: AxiosResponse) {
                    previewOrderData.userRxdata = response.data;
                }).catch(function (error: AxiosError) {
                    previewOrderData.userRxdata = [];
                });

            } else if (indexVal === 1) {

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}getFiles?orderId=${orderno}`,
                    headers: {
                        sessionid: sessionid || ''
                    },
                }).then(function (response: AxiosResponse) {
                    previewOrderData.getFileData = response.data;
                }).catch(function (error: AxiosError) {
                    previewOrderData.getFileData = [];
                });

            } else if (indexVal === 2) {

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}getOrderMessage?messageType=0&pid=${orderno}`,
                    headers: {
                        sessionid: sessionid || ''
                    },
                }).then(function (response: AxiosResponse) {
                    previewOrderData.getUserMessage = response.data;
                }).catch(function (error: AxiosError) {
                    previewOrderData.getUserMessage = [];
                });

            } else if (indexVal === 3) {

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}getCaseNotes`,
                    headers: {
                        orderno: orderno,
                        sessionid: sessionid || ''
                    },
                }).then(function (response: AxiosResponse) {
                    previewOrderData.caseNotes = response.data[0].casenotes;
                }).catch(function (error: AxiosError) {
                    previewOrderData.caseNotes = '';
                });

            }
        }
        dispatch({ type: STORE_M_PREVIEWORDER_DATA, previewOrderData } as AnyAction);

        return true;
    };
};

export const stopTimerProductionStatus = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    if (productionStatusTimer) {
        clearInterval(productionStatusTimer);
    } else {
        clearInterval(productionStatusTimer);
    }
    const mfilterLessOrderData: RowDataManufactur[] = [];
    dispatch({ type: STORE_M_FILTERLESS_DATA, mfilterLessOrderData } as AnyAction);
};



// WEBPACK FOOTER //
// ./src/actions/manufacturAction.ts